// extracted by mini-css-extract-plugin
export default {"menuBlock":"YF-z","title":"ZF-z","nav":"_F-z","flexCell":"aG-z","facetLink":"bG-z"};